import * as yup from 'yup';

function checkContactPreference(this: yup.TestContext, value) {
  const contact_preference = this.parent?.contact_preference;
  return (value && value.length > 0) || (contact_preference && contact_preference.length > 0);
}

function checkContactPreferenceAlternate(this: yup.TestContext, value) {
  const contact_preference = this.parent?.contact_preference;
  return (value && value.length > 0) || (contact_preference && contact_preference.length > 0);
}

const SellerContactValidation = yup.object()
  .shape({
    name: yup.string()
      .required('Name is required.')
      .max(255, 'Must be less than 255 characters'),
    email: yup.string()
      .email()
      .required('A valid email address is required.'),
    phone: yup.string()
      .when(['alternate_phone'], {
        is: (alternate_phone) => !!alternate_phone,
        then: yup.string()
          .required('Phone is required when Alt Phone is specified.'),
        otherwise: yup.string()
          .nullable()
          .test('nullable-phone', 'Please enter a valid phone number.', (value) => {
            return value
              ? yup.string()
                .isValidSync(value)
              : true;
          }),
      })
      .when(['contact_preference'], {
        // If contact_preference includes text or call, then the phone field is required
        is: (contact_preference, phone) => !phone && (contact_preference.includes('text') || contact_preference.includes('call')),
        then: yup.string()
          .required('Phone is required when your contact preference is text or call.'),
        otherwise: yup.string()
          .nullable(),
      }),
    phone_extn: yup.string()
      .nullable()
      .matches(/^[0-9]+$/, 'Must be only digits'),
    alternate_phone: yup.string()
      .nullable()
      .test('nullable-phone', 'Please enter a valid phone number.', (value) => {
        return value
          ? yup.string()
            .isValidSync(value)
          : true;
      })
      .when(['contact_preference_alternate'], {
        // If contact_preference includes text or call, then the phone field is required
        is: (contact_preference_alternate, phone) => !phone && (contact_preference_alternate.includes('text') || contact_preference_alternate.includes('call')),
        then: yup.string()
          .required('Alternate phone is required when your contact preference is text or call.'),
        otherwise: yup.string()
          .nullable(),
      }),
    alternate_phone_extn: yup.string()
      .nullable()
      .matches(/^[0-9]+$/, 'Must be only digits'),
    best_time_to_call: yup.string()
      .nullable()
      .max(200, 'Must be less than 200 characters'),
    contact_preference: yup
      .array()
      .of(yup.string())
      .test('at-least-one-preference', 'You must select at least one contact preference', checkContactPreference),
    contact_preference_alternate: yup
      .array()
      .of(yup.string())
      .test('at-least-one-preference', 'You must select at least one contact preference', checkContactPreferenceAlternate),
  });

export default SellerContactValidation;
